import React from 'react'
import Phone from './Phone';

export default function PhoneIndexList({oym,list}) {
    console.log(list);
    return (
         list.map(phoneNumber => {
             console.log(phoneNumber);
             let phoneNumberObject=oym.objectRef(phoneNumber);
             console.log(phoneNumberObject);
             return <Phone key={phoneNumberObject.id} oym={oym} phone={phoneNumberObject} />
         })
    )
}
